module.exports = ".height88 {\n  height: 88vh;\n}\n.s-message {\n  font-size: 10vh;\n  color: green;\n  font-weight: 700;\n}\n.e-message {\n  font-size: 10vh;\n  color: red;\n  font-weight: 700;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/reusable/stipe-connect/stipe-connect.component.css
// module id = ./src/app/shared/reusable/stipe-connect/stipe-connect.component.css
// module chunks = main